export default "__VITE_ASSET__c4ca306d__"